export const ROWRENDERERCONST = {
    CONTRACTS: "CONTRACTS",
    CONTRACT_TEAMS: "CONTRACT_TEAMS",
    ORDERS: "ORDERS",
    OUTCOMES: "OUTCOMES",
    OUTCOMES_FINANCIAL_CONDITIONS_REBATE_AT_INFUSION:
        "OUTCOMES_FINANCIAL_CONDITIONS_REBATE_AT_INFUSION",
    OUTCOMES_FINANCIAL_CONDITIONS_REBATE_AT_APHERESIS:
        "OUTCOMES_FINANCIAL_CONDITIONS_REBATE_AT_APHERESIS",
    OUTCOME_CONTRACT_SELECTION: "OUTCOME_CONTRACT_SELECTION",
    OUTCOME_ORDER_SELECTION: "OUTCOME_ORDER_SELECTION",
    PARTNERS: "PARTNERS",
    PRICES: "PRICES",
    PRODUCTS: "PRODUCTS",
    ONGOING_TASKS: "ONGOING_TASKS",
    COMPLETED_TASKS: "COMPLETED_TASKS",
    TASKS: "TASKS",
    FINANCES_OUTCOMES: "FINANCES_OUTCOMES",
    BPF: "BPF",
    CREDIT_NOTES_OUTCOME: "CREDIT_NOTES_OUTCOME",
    CREDIT_NOTES_CLAIM: "CREDIT_NOTES_CLAIM",
    INVOICE_RELEASE: "INVOICE_RELEASE",
    TRANSACTION_VALUES: "TRANSACTION_VALUES",
    BILLING_PLAN: "BILLING_PLAN",
    MILESTONE: "MILESTONE",
    FINANCIAL_CONDITIONS: "FINANCIAL_CONDITIONS",
    MAINTENANCE_FINANCIAL_CONDITIONS: "MAINTENANCE_FINANCIAL_CONDITIONS",
    PRODUCT_CONDITIONS: "PRODUCT_CONDITIONS",
    OUTCOME_FINANCIAL_TRANSACTIONS: "OUTCOME_FINANCIAL_TRANSACTIONS",
    REGION: "REGION",
    CONTEXT: "CONTEXT",
    EXTERNAL_CODES: "EXTERNAL_CODES",
    MODEL: "MODEL",
    CATEGORY: "CATEGORY",
    LINK_CATEGORY: "LINK_CATEGORY",
    CONTRACT_CATEGORY: "CONTRACT_CATEGORY",
    SCALES_OVERVIEW: "SCALES_OVERVIEW",
    SCALES_WITH_ACTION: "SCALES_WITH_ACTION",
    CLAIM: "CLAIM",
    CLAIM_CONTRACT: "CLAIM_CONTRACT",
    CLAIM_CONTRACT_SELECTION: "CLAIM_CONTRACT_SELECTION",
    BPF_CLAIMS: "BPF_CLAIMS",
    CLAIM_FINANCIAL_TRANSACTIONS: "CLAIM_FINANCIAL_TRANSACTIONS",
    MAINTENANCE_USERS: "MAINTENANCE_USERS",
    MAINTENANCE_ROLES: "MAINTENANCE_ROLES",
    __PICKED_TEAM: "__PICKED_TEAM", // Stored team in local storage
    ADVANCED_SCALES_WITH_ACTION: "ADVANCED_SCALES_WITH_ACTION",
    BPF_OUTCOME_CONTRACT_SELECTION: "BPF_OUTCOME_CONTRACT_SELECTION",
    CLAIM_DETAIL_LINES: "CLAIM_DETAIL_LINES",
    COMPENSATION: "COMPENSATION",
    CLAIM_COMPENSATION: "CLAIM_COMPENSATION",
    MAINTENANCE_CONTRACT_MILESTONES_DMN: "MAINTENANCE_CONTRACT_MILESTONES_DMN",
    GENTLEMAN_AGREEMENT: "GENTLEMAN_AGREEMENT",
    ADVANCE_CLAIM: "ADVANCE_CLAIM",
};

export const filterByCountry = (headers: any, countryIsoCode: string) => {
    return headers.filter(
        (item: any) =>
            (!item?.showForCountries?.length ||
                item?.showForCountries.includes(countryIsoCode)) &&
            !item?.hiddenForCountries?.includes(countryIsoCode),
    );
};

export const HEADERS = {
    CONTRACTS: [
        {
            header: "",
            viewingOption: "",
            rowKey: "",
        },
        {
            header: "Contract Reference",
            viewingOption: "Contract reference",
            rowKey: "reference",
        },
        {
            header: "Brand",
            viewingOption: "Brand",
            rowKey: "brandName",
        },
        {
            header: "Therapeutic Area",
            viewingOption: "Therapeutic Area",
            rowKey: "therapeuticAreaName",
        },
        {
            header: "Primary Contract Partner",
            viewingOption: "Primary Contract Partner",
            rowKey: "primaryContractPartner",
        },
        {
            header: "Additional Partners",
            viewingOption: "Additional Partners",
            rowKey: "additionalPartners",
        },
        {
            header: "Product",
            viewingOption: "Product",
            rowKey: "products",
            unchecked: true,
        },
        {
            header: "Categories",
            viewingOption: "Categories",
            rowKey: "categories",
            unchecked: true,
        },
        {
            header: "start date",
            viewingOption: "Start date",
            rowKey: "validFrom",
        },
        {
            header: "end date",
            viewingOption: "End date",
            rowKey: "validTo",
        },
        {
            header: "Status",
            viewingOption: "Status",
            rowKey: "status",
        },
        {
            header: "",
            viewingOption: "",
            rowKey: "",
        },
    ],
    CONTRACT_TEAMS: [
        {
            header: "",
        },
        {
            header: "Team Name",
            viewingOption: "Team Name",
            rowKey: "teamName",
        },
        {
            header: "Country",
            viewingOption: "Country",
            rowKey: "countries",
        },
        {
            header: "Therapeutic Area",
            viewingOption: "Therapeutic Area",
            rowKey: "therapeuticAreaIds",
        },
        {
            header: "Members",
            viewingOption: "Members",
            rowKey: "users",
        },
        {
            header: "Min. Contract Reviewers",
            viewingOption: "Min. Contract Reviewers",
            rowKey: "minimumContractReviewers",
        },
        {
            header: "Min. Financial Approvers",
            viewingOption: "Min. Financial Approvers",
            rowKey: "minimumFinancialApprovers",
        },
        {
            header: "",
        },
    ],
    ORDERS: [
        {
            header: "SAP Order Number",
            viewingOption: "SAP Order Number",
            rowKey: "sapOrderNo",
        },
        {
            header: "Cquence Id",
            viewingOption: "Cquence Id",
            rowKey: "cquenceId",
        },
        {
            header: "Order Status",
            viewingOption: "Order Status",
            rowKey: "orderStatus",
        },
        {
            header: "Ship To",
            viewingOption: "Ship To",
            rowKey: "treatmentSite",
        },
        {
            header: "Sold to",
            viewingOption: "Sold to",
            rowKey: "soldToName",
            showForCountries: ["ES"],
        },
        {
            header: "Payer",
            viewingOption: "Payer",
            rowKey: "payerName",
            showForCountries: ["ES"],
        },

        {
            header: "Contract Reference",
            viewingOption: "Contract Reference",
            rowKey: "contractReference",
            hiddenForCountries: ["ES"],
        },
        {
            header: "Order Date",
            viewingOption: "Order Date",
            rowKey: "orderDate",
        },

        {
            header: "Infusion Date",
            viewingOption: "Infusion Date",
            rowKey: "infusionDate",
        },
        {
            header: "PO Received",
            viewingOption: "PO Received",
            rowKey: "poReceived",
            showForCountries: ["ES"],
        },
        {
            header: "Free of Charge",
            viewingOption: "Free of Charge",
            rowKey: "freeOfCharge",
            checkedForCountries: ["ES", "PT"],
        },
        {
            header: "Private Insurer",
            viewingOption: "Private Insurer",
            rowKey: "privateInsurer",
            checkedForCountries: ["ES", "PT"],
        },
        {
            header: "Brand",
            viewingOption: "Brand",
            rowKey: "brand",
            unchecked: true,
        },

        {
            header: "Indication",
            viewingOption: "Indication",
            rowKey: "indication",
            unchecked: true,
        },

        {
            header: "Milestones Met",
            viewingOption: "Milestones Met",
            rowKey: "milestonesMet",
            showForCountries: ["ES"],
        },
        {
            header: "Milestone To Approve",
            viewingOption: "Milestone To Approve",
            rowKey: "milestoneToApprove",
            showForCountries: ["ES"],
        },
        {
            header: "",
            viewingOption: "",
        },
    ],
    OUTCOMES: [
        {
            header: "Contract Reference",
            viewingOption: "Contract Reference",
            rowKey: "contractRef",
        },
        {
            header: "SAP order number",
            viewingOption: "SAP order number",
            rowKey: "sapOrderNo",
        },
        {
            header: "Cquence Id",
            viewingOption: "Cquence Id",
            rowKey: "salessystemOrderId",
        },
        {
            header: "Infusion Date",
            viewingOption: "Infusion Date",
            rowKey: "infusionDate",
        },
        {
            header: "Milestone",
            viewingOption: "Milestone",
            rowKey: "milestoneNumber",
        },
        {
            header: "Milestone Met",
            viewingOption: "Milestone Met",
            rowKey: "milestoneMet",
            showForCountries: ["ES", "DE", "FR", "IT", "NL", "BE", "CH"],
        },
        {
            header: "Patient alive",
            viewingOption: "Patient alive",
            rowKey: "milestoneMet",
            showForCountries: ["GB"],
        },
        {
            header: "Measure",
            viewingOption: "Measure",
            rowKey: "measure",
        },
        {
            header: "Action",
            viewingOption: "Outcome Action",
            rowKey: "outcomeAction",
            unchecked: true,
        },
        {
            header: "Outcome Date",
            viewingOption: "Outcome Date",
            rowKey: "outcomeDate",
        },
        {
            header: "FOC",
            viewingOption: "FOC",
            rowKey: "freeOfCharge",
            showForCountries: ["ES", "PT"],
        },
        {
            header: "Processed In SAP",
            viewingOption: "Processed In SAP",
            rowKey: "processedInSAP",
            showForCountries: ["ES", "PT"],
        },
        {
            header: "Status",
            viewingOption: "Status",
            rowKey: "status",
        },
        {
            header: "",
            viewingOption: "",
        },
    ],
    OUTCOMES_FINANCIAL_CONDITIONS_REBATE_AT_INFUSION: [
        {
            header: "Contract Reference",
            viewingOption: "Contract Reference",
            rowKey: "contractRef",
        },
        {
            header: "Cquence Id",
            viewingOption: "Cquence Id",
            rowKey: "salessystemOrderId",
        },
        {
            header: "Infusion Date",
            viewingOption: "Infusion Date",
            rowKey: "infusionDate",
        },
        {
            header: "Financial Trigger Type",
            viewingOption: "Financial Trigger Type",
            rowKey: "financialTriggerType",
        },
        {
            header: "Action",
            viewingOption: "Financial Conditions Action",
            rowKey: "outcomeAction",
        },
        {
            header: "Status",
            viewingOption: "Status",
            rowKey: "status",
        },
        {
            header: "",
            viewingOption: "",
        },
    ],
    OUTCOMES_FINANCIAL_CONDITIONS_REBATE_AT_APHERESIS: [
        {
            header: "Contract Reference",
            viewingOption: "Contract Reference",
            rowKey: "contractRef",
        },
        {
            header: "Cquence Id",
            viewingOption: "Cquence Id",
            rowKey: "salessystemOrderId",
        },
        {
            header: "Apheresis date",
            viewingOption: "Apheresis date",
            rowKey: "apheresisCompletionDate",
        },
        {
            header: "Financial Trigger Type",
            viewingOption: "Financial Trigger Type",
            rowKey: "financialTriggerType",
        },
        {
            header: "Action",
            viewingOption: "Financial Conditions Action",
            rowKey: "outcomeAction",
        },
        {
            header: "Status",
            viewingOption: "Status",
            rowKey: "status",
        },
        {
            header: "",
            viewingOption: "",
        },
    ],
    //split on | for rendering on 2 lines
    OUTCOME_CONTRACT_SELECTION: [
        {
            header: "",
        },
        {
            header: "Ref",
        },
        {
            header: "Contract Partner",
        },
        {
            header: "Additional Partners",
        },
        {
            header: "Product |& Indication",
        },
        {
            header: "Valid From |& To",
        },
    ],
    OUTCOME_ORDER_SELECTION: [
        {
            header: "",
        },
        {
            header: "Product",
        },
        {
            header: "Infusion Date",
        },
        {
            header: "Ship To",
        },

        {
            header: "Cquence Id",
        },
    ],
    //split on | for rendering on 2 lines
    PARTNERS: [
        {
            header: "Name",
            viewingOption: "Name",
            rowKey: "name",
        },
        {
            header: "Account|Type",
            viewingOption: "Account Type",
            rowKey: "type",
        },
        {
            header: "Address",
            viewingOption: "Address",
            rowKey: "address",
        },
        {
            header: "SAP Code",
            viewingOption: "SAP Code",
            rowKey: "sapAccountCode",
        },
        {
            header: "Knowyour-|Supplier Id",
            viewingOption: "Knowyour-|Supplier Id",
            rowKey: "knowyoursupplierid",
        },
        {
            header: "Bank Type",
            viewingOption: "Bank Type",
            rowKey: "bankType",
        },
        {
            header: "Country|of Sale",
            viewingOption: "Country of Sale",
            rowKey: "countryOfSale",
        },
        {
            header: "Cods ID",
            viewingOption: "Cods ID",
            rowKey: "codsId",
            showForCountries: ["GB"],
        },
        {
            header: "Trust Account",
            viewingOption: "Trust Account",
            rowKey: "trustAccountCode",
            showForCountries: ["GB"],
        },
        {
            header: "Region",
            viewingOption: "Region",
            rowKey: "regionCode",
            showForCountries: ["GB"],
        },
        {
            header: "Consortia",
            viewingOption: "Consortia",
            rowKey: "cmuRegionCode",
            showForCountries: ["GB"],
        },
        {
            header: "National Buying Group Combined",
            viewingOption: "National Buying Group Combined",
            rowKey: "regionCode1",
            showForCountries: ["GB"],
        },
        {
            header: "National Buying Group",
            viewingOption: "National Buying Group",
            rowKey: "regionCode2",
            showForCountries: ["GB"],
        },
        {
            header: "Status",
            viewingOption: "Status",
            rowKey: "status",
        },
        {
            header: "",
            viewingOption: "",
            rowKey: "",
        },
    ],
    PRICES: [
        {
            header: "CONDITION",
        },
        {
            header: "VALID FROM",
        },

        {
            header: "VALID TILL",
        },
        {
            header: "PRICE",
        },
        // pricelist is only for netherlands, so added country condition
        {
            header: "PRICE LIST",
            showForCountries: ["NL"],
        },
        {
            header: "CURRENCY",
        },
        {
            header: "",
        },
    ],
    FINANCIAL_CONDITIONS: [
        {
            header: "NAME",
        },
        {
            header: "TYPE",
        },
        {
            header: "DESCRIPTION",
        },
        {
            header: "",
        },
    ],
    PRODUCTS: [
        {
            header: "Name",
            viewingOption: "Name",
            rowKey: "productName",
        },
        {
            header: "Organisation",
            viewingOption: "Organisation",
            rowKey: "salesOrg",
        },
        {
            header: "SAP SKU Number",
            viewingOption: "SAP SKU Number",
            rowKey: "sapSkuNo",
        },

        {
            header: "Brand",
            viewingOption: "Brand",
            rowKey: "brandName",
        },
        {
            header: "Status",
            viewingOption: "Status",
            rowKey: "status",
        },
        {
            header: "Country",
            viewingOption: "Country",
            rowKey: "country",
        },
        {
            header: "",
            viewingOption: "",
            rowKey: "",
        },
    ],
    ONGOING_TASKS: [
        {
            header: "Name",
            viewingOption: "Name",
            rowKey: "name",
        },
        {
            header: "Contract Reference",
            viewingOption: "Contract Reference",
            rowKey: "contractRef",
        },
        {
            header: "Task Definition Key",
            viewingOption: "Task Definition Key",
            rowKey: "taskDefinitionKey",
        },
        {
            header: "Category",
            viewingOption: "Category",
            rowKey: "category",
        },
        {
            header: "Cquence Id",
            viewingOption: "Cquence Id",
            rowKey: "salessystemOrderId",
        },
        {
            header: "Supplier Name",
            viewingOption: "Supplier Name",
            rowKey: "supplierName",
            unchecked: true,
        },
        {
            header: "Claim Number",
            viewingOption: "Claim Number",
            rowKey: "claimNo",
            unchecked: true,
        },
        {
            header: "Date Added",
            viewingOption: "Date Added",
            rowKey: "created",
        },
    ],
    COMPLETED_TASKS: [
        {
            header: "Name",
            viewingOption: "Name",
            rowKey: "name",
        },
        {
            header: "Contract Reference",
            viewingOption: "Contract Reference",
            rowKey: "contractRef",
        },
        {
            header: "Task Definition Key",
            viewingOption: "Task Definition Key",
            rowKey: "taskDefinitionKey",
        },
        {
            header: "Category",
            viewingOption: "Category",
            rowKey: "category",
        },
        {
            header: "Cquence Id",
            viewingOption: "Cquence Id",
            rowKey: "salessystemOrderId",
        },
        {
            header: "Supplier Name",
            viewingOption: "Supplier Name",
            rowKey: "supplierName",
            unchecked: true,
        },
        {
            header: "Claim Number",
            viewingOption: "Claim Number",
            rowKey: "claimNo",
            unchecked: true,
        },
        {
            header: "Date Added",
            viewingOption: "Date Added",
            rowKey: "created",
        },
        {
            header: "Approved",
            viewingOption: "Approved",
            rowKey: "approved",
        },
        {
            header: "",
            viewingOption: "",
            rowKey: "",
        },
    ],
    FINANCES_OUTCOMES: [
        {
            header: "",
        },
        {
            header: "Contract Reference",
        },
        {
            header: "Therapeutic Area Name",
        },
        {
            header: "Product Name",
        },
        {
            header: "SAP SKU number",
        },
        {
            header: "Cquence Id",
        },
        {
            header: "Creation Date|End Date",
        },
        {
            header: "Amount",
        },
    ],
    BPF: [
        {
            header: "BPF Name",
            viewingOption: "BPF Name",
            rowKey: "bpfName",
        },
        {
            header: "Date Processed",
            viewingOption: "Date Processed",
            rowKey: "dateProcessed",
        },
        {
            header: "Contract Reference",
            viewingOption: "Contract Reference",
            rowKey: "contractRef",
        },
        {
            header: "Contract Type",
            viewingOption: "Contract Type",
            rowKey: "contractType",
        },
        {
            header: "Payment Registration Number",
            viewingOption: "Payment Registration Number",
            rowKey: "customerRef",
        },
        {
            header: "Contract Partner",
            viewingOption: "Contract Partner",
            rowKey: "primaryContractPartner",
        },
        {
            header: "type",
            viewingOption: "type",
            rowKey: "financeType",
        },
        {
            header: "Status",
            viewingOption: "Status",
            rowKey: "status",
        },
        {
            header: "",
            viewingOption: "",
            rowKey: "",
        },
    ],
    CREDIT_NOTES_OUTCOME: [
        {
            header: "Contract Reference",
            viewingOption: "Contract Reference",
            rowKey: "contractRef",
        },
        {
            header: "Treatment site",
            viewingOption: "Treatment site",
            rowKey: "accountName",
        },
        {
            header: "Infusion date",
            viewingOption: "Infusion date",
            rowKey: "infusionDate",
        },
        {
            header: "Cquence id",
            viewingOption: "Cquence id",
            rowKey: "salessystemOrderId",
        },
        {
            header: "SAP order number",
            viewingOption: "SAP order number",
            rowKey: "sapOrderNo",
        },
        {
            header: "SCP ref",
            viewingOption: "SCP ref",
            rowKey: "scpRefNo",
        },
        {
            header: "Milestone",
            viewingOption: "Milestone",
            rowKey: "milestoneNo",
        },
        {
            header: "Amount",
            viewingOption: "Amount",
            rowKey: "amount",
        },
        {
            header: "PCT.",
            viewingOption: "PCT.",
            rowKey: "percentage",
        },
        {
            header: "Outcome date",
            viewingOption: "Outcome date",
            rowKey: "createdAt",
        },
        {
            header: "Date processed",
            viewingOption: "Date processed",
            rowKey: "processedAt",
        },
        {
            header: "Status",
            viewingOption: "Status",
            rowKey: "status",
        },
        {
            header: "",
        },
    ],
    CREDIT_NOTES_CLAIM: [
        {
            header: "Claim number",
            viewingOption: "Claim number",
            rowKey: "claimNo",
        },
        {
            header: "Account",
            viewingOption: "Account",
            rowKey: "accountName",
        },
        {
            header: "Contract Reference",
            viewingOption: "Contract Reference",
            rowKey: "contractRef",
        },
        {
            header: "Claim customer reference",
            viewingOption: "Claim customer reference",
            rowKey: "claimCustomerReference",
        },
        {
            header: "Claim status",
            viewingOption: "Claim status",
            rowKey: "claimStatus",
        },
        {
            header: "",
        },
    ],
    INVOICE_RELEASE: [
        {
            header: "Contract Reference",
            viewingOption: "Contract Reference",
            rowKey: "contractRef",
        },

        {
            header: "Treatment site",
            viewingOption: "Treatment site",
            rowKey: "accountName",
        },
        {
            header: "Infusion date",
            viewingOption: "Infusion date",
            rowKey: "infusionDate",
        },
        {
            header: "Cquence id",
            viewingOption: "Cquence id",
            rowKey: "salessystemOrderId",
        },
        {
            header: "SAP order number",
            viewingOption: "SAP order number",
            rowKey: "sapOrderNo",
        },
        {
            header: "SCP ref",
            viewingOption: "SCP ref",
            rowKey: "scpRefNo",
        },
        {
            header: "Milestone",
            viewingOption: "Milestone",
            rowKey: "milestoneNo",
        },
        {
            header: "Milestone met",
            viewingOption: "Milestone met",
            rowKey: "milestoneMet",
        },
        {
            header: "Billing block",
            viewingOption: "Billing block",
            rowKey: "billingBlock",
        },

        {
            header: "Date processed",
            viewingOption: "Date processed",
            rowKey: "processedAt",
        },
        {
            header: "Status",
            viewingOption: "Status",
            rowKey: "status",
        },
        {
            header: "",
        },
    ],
    TRANSACTION_VALUES: [
        {
            rowKey: "countryIsoCode",
            header: "Country",
        },
        {
            rowKey: "brandId",
            header: "Brand",
        },
        {
            rowKey: "salesOrg",
            header: "Organisation",
        },
        {
            rowKey: "division",
            header: "Division",
        },
        {
            rowKey: "distributionChannel",
            header: "Distribution channel",
        },
        {
            rowKey: "orderType",
            header: "Order type",
        },
        {
            rowKey: "conditionType",
            header: "Condition",
        },
        {
            rowKey: "bpfId",
            header: "Bpf Id",
        },
        {
            rowKey: "entryType",
            header: "Entry type",
        },
        {
            rowKey: "legalEntity",
            header: "Legal entity",
        },
        {
            rowKey: "fullReportingMrc",
            header: "MRC",
        },
        {
            rowKey: "organizationalUnit",
            header: "Organizational unit",
        },
        {
            rowKey: "transactionType",
            header: "Transaction type",
        },
        {
            rowKey: "debetCredit",
            header: "Debet credit",
        },
        {
            rowKey: "accountType",
            header: "Account type",
        },
        {
            rowKey: "paymentTerms",
            header: "Payment terms",
        },
        {
            rowKey: "paymentMethod",
            header: "Payment method",
        },
        {
            rowKey: "glAccount",
            header: "GL account",
        },

        {
            rowKey: "commodityCode",
            header: "Commodity code",
        },
        {
            rowKey: "companyCode",
            header: "Company code",
        },
        {
            rowKey: "taxCode",
            header: "Tax code",
        },
        {
            rowKey: "referenceDocument",
            header: "Reference document",
        },
        {
            rowKey: "cnReferenceQualifier",
            header: "CN reference qualifier",
        },
        {
            rowKey: "hccProfessionalPayment",
            header: "HCC Professional Payment",
        },
        {
            rowKey: "hccProductRebate",
            header: "HCC Product Rebate",
        },
        {
            rowKey: "hccGovernmentIndicator",
            header: "HCC Government Indicator",
        },
        {
            header: "",
        },
    ],
    BILLING_PLAN: [
        {
            rowKey: "salesOrg",
            viewingOption: "Organisation",
            header: "Organisation",
        },
        {
            rowKey: "documentType",
            viewingOption: "Document Type",
            header: "Document Type",
        },
        {
            rowKey: "division",
            viewingOption: "Division",
            header: "Division",
        },
        {
            rowKey: "planType",
            viewingOption: "Plan Type",
            header: "Plan Type",
        },
        {
            rowKey: "counter",
            viewingOption: "Counter",
            header: "Counter",
        },
        {
            rowKey: "days",
            viewingOption: "Days",
            header: "Days",
        },
        {
            rowKey: "percentage",
            viewingOption: "Percentage",
            header: "Percentage",
        },
        {
            rowKey: "paymentTerms",
            viewingOption: "Payment Terms",
            header: "Payment Terms",
        },
        {
            rowKey: "billingBlock",
            viewingOption: "Billing Block",
            header: "Billing Block",
        },
        {
            header: "",
            viewingOption: "",
            rowKey: "",
        },
    ],
    MILESTONE: [
        {
            rowKey: "milestoneNo",
            viewingOption: "Milestone number",
            header: "Milestone number",
        },
        {
            rowKey: "milestoneDescr",
            viewingOption: "Milestone description",
            header: "Milestone description",
        },
        {
            rowKey: "contractRef",
            viewingOption: "Contract Reference",
            header: "Contract Reference",
        },
        {
            rowKey: "validFrom",
            viewingOption: "Start date",
            header: "Start date",
        },
        {
            rowKey: "validTo",
            viewingOption: "End date",
            header: "End date",
        },
        {
            rowKey: "productName",
            viewingOption: "Product name",
            header: "Product name",
        },
        {
            header: "",
        },
    ],
    MAINTENANCE_FINANCIAL_CONDITIONS: [
        {
            rowKey: "name",
            viewingOption: "Name",
            header: "Name",
        },
        {
            rowKey: "description",
            viewingOption: "Description",
            header: "Description",
        },
        {
            rowKey: "camundaDecisionTableId",
            viewingOption: "DMN ID",
            header: "DMN ID",
        },
        {
            header: "",
        },
    ],
    PRODUCT_CONDITIONS: [
        {
            header: "Name",
            viewingOption: "Name",
            rowKey: "productName",
        },
        {
            header: "Organisation",
            viewingOption: "Organisation",
            rowKey: "salesOrg",
        },
        {
            header: "SAP SKU number",
            viewingOption: "SAP SKU number",
            rowKey: "sapSkuNo",
        },

        {
            header: "Status",
            viewingOption: "Status",
            rowKey: "status",
        },
        {
            header: "Country",
            viewingOption: "Country",
            rowKey: "country",
        },
        {
            header: "",
            viewingOption: "",
            rowKey: "",
        },
    ],

    OUTCOME_FINANCIAL_TRANSACTIONS: [
        {
            header: "",
            rowKey: "",
        },
        {
            header: "Cquence number",
            rowKey: "cquence_number",
        },
        {
            header: "SAP order number",
            rowKey: "sap_order_no",
        },

        {
            header: "Amount",
            rowKey: "amount",
        },
        {
            header: "Measure",
            rowKey: "measure",
        },

        {
            header: "Percentage",
            rowKey: "percentage",
        },

        {
            header: "VAT percentage",
            rowKey: "vat_percentage",
        },

        {
            header: "VAT amount",
            rowKey: "vat_amount",
        },
        {
            header: "Status",
            rowKey: "status",
        },
    ],
    CONTEXT: [
        {
            header: "Name",
            viewingOption: "Name",
            rowKey: "contextName",
        },
        {
            header: "Type",
            viewingOption: "Type",
            rowKey: "type",
        },
        {
            header: "Country",
            viewingOption: "Country",
            rowKey: "country",
        },
        {
            header: "",
            viewingOption: "",
            rowKey: "",
        },
    ],
    REGION: [
        {
            header: "Type",
            viewingOption: "Type",
            rowKey: "type",
        },
        {
            header: "Code",
            viewingOption: "Code",
            rowKey: "code",
        },
        {
            header: "Name",
            viewingOption: "Name",
            rowKey: "name",
        },
        {
            header: "Tender region code",
            viewingOption: "Tender region code",
            rowKey: "tenderRegionCode",
            showForCountries: ["GB"],
        },
        {
            header: "Parent region code",
            viewingOption: "Parent region code",
            rowKey: "parentRegionCode",
            showForCountries: ["GB"],
        },
        {
            header: "Region account field",
            viewingOption: "Region account field",
            rowKey: "regionAccountField",
            showForCountries: ["GB"],
        },
        {
            header: "",
            rowKey: "",
        },
    ],

    EXTERNAL_CODES: [
        {
            header: "Context",
            viewingOption: "Context",
            rowKey: "context",
        },
        {
            header: "External code",
            viewingOption: "External code",
            rowKey: "code",
        },
        {
            header: "External name",
            viewingOption: "External name",
            rowKey: "name",
        },
        {
            header: "Status",
            viewingOption: "Status",
            rowKey: "status",
        },
        {
            header: "",
            rowKey: "",
        },
    ],
    MODEL: [
        {
            header: "Name",
            viewingOption: "Name",
            rowKey: "name",
        },
        {
            header: "Country",
            viewingOption: "Country",
            rowKey: "country",
        },
        {
            header: "Currency",
            viewingOption: "Currency",
            rowKey: "currency",
        },
        {
            header: "Type",
            viewingOption: "Type",
            rowKey: "type",
        },
        {
            header: "Data source",
            viewingOption: "Data source",
            rowKey: "dataSource",
        },
        {
            header: "Price source",
            viewingOption: "Price Source",
            rowKey: "priceSource",
        },
        {
            header: "DMN Id",
            viewingOption: "DMN Id",
            rowKey: "dmnId",
        },
        {
            header: "Account context",
            viewingOption: "Account context",
            rowKey: "accountContext",
        },
        {
            header: "Region context",
            viewingOption: "Region context",
            rowKey: "regionContext",
        },
        {
            header: "Product context",
            viewingOption: "Product context",
            rowKey: "productContext",
        },
        {
            header: "Allowed tolerance percentage on units",
            viewingOption: "Allowed tolerance percentage on units",
            rowKey: "allowedTotalUnitsTolerance",
        },
        {
            header: "No.of linked categories",
            viewingOption: "No.of linked categories",
            rowKey: "nrCategories",
        },
        {
            header: "",
            rowKey: "",
        },
    ],
    CATEGORY: [
        {
            header: "Category name",
            viewingOption: "Category name",
            rowKey: "categoryName",
        },
        {
            header: "Category label",
            viewingOption: "Category label",
            rowKey: "categoryLabel",
        },
        {
            header: "Category value",
            viewingOption: "Category value",
            rowKey: "categoryValue",
        },
        {
            header: "Country",
            viewingOption: "Country",
            rowKey: "country",
        },
        {
            header: "Type",
            viewingOption: "Type",
            rowKey: "type",
        },
        {
            header: "",
            rowKey: "",
        },
    ],
    LINK_CATEGORY: [
        {
            header: "",
            rowKey: "",
        },
        {
            header: "Category name",
            viewingOption: "Category name",
            rowKey: "categoryName",
        },
        {
            header: "Category value",
            viewingOption: "Category value",
            rowKey: "categoryValue",
        },
    ],
    CONTRACT_CATEGORY: [
        {
            header: "Category label",
            viewingOption: "Category label",
            rowKey: "categoryLabel",
        },
        {
            header: "Category value",
            viewingOption: "Category value",
            rowKey: "categoryValue",
        },
        {
            header: "",
            rowKey: "",
        },
    ],
    SCALES_OVERVIEW: [
        {
            header: "Price",
            viewingOption: "Price",
            rowKey: "price",
        },
        {
            header: "Currency",
            viewingOption: "Currency",
            rowKey: "currency",
        },
        {
            header: "Discount percentage",
            viewingOption: "Discount percentage",
            rowKey: "discountPercentage",
        },
        {
            header: "Unit of measure from",
            viewingOption: "Unit of measure from",
            rowKey: "unitOfMeasureFrom",
        },
        {
            header: "Unit of measure to",
            viewingOption: "Unit of measure to",
            rowKey: "unitOfMeasureTo",
        },
        {
            header: "Unit of measure",
            viewingOption: "Unit of measure",
            rowKey: "unitOfMeasure",
        },
        {
            header: "Period from",
            viewingOption: "Period from",
            rowKey: "periodFrom",
        },
        {
            header: "Period to",
            viewingOption: "Period to",
            rowKey: "periodTo",
        },
    ],
    SCALES_WITH_ACTION: [
        {
            header: "Price",
            viewingOption: "Price",
            rowKey: "price",
        },
        {
            header: "Discount percentage",
            viewingOption: "Discount percentage",
            rowKey: "discountPercentage",
        },
        {
            header: "Unit of measure from",
            viewingOption: "Unit of measure from",
            rowKey: "unitOfMeasureFrom",
        },
        {
            header: "Unit of measure to",
            viewingOption: "Unit of measure to",
            rowKey: "unitOfMeasureTo",
        },
        {
            header: "Unit of measure",
            viewingOption: "Unit of measure",
            rowKey: "unitOfMeasure",
        },
        {
            header: "Period from",
            viewingOption: "Period from",
            rowKey: "periodFrom",
        },
        {
            header: "Period to",
            viewingOption: "Period to",
            rowKey: "periodTo",
        },
        {
            header: "",
            rowKey: "",
        },
    ],
    ADVANCED_SCALES_WITH_ACTION: [
        {
            header: "Scale Period from",
            rowKey: "periodFrom",
        },
        {
            header: "Scale Period to",
            rowKey: "periodTo",
        },
        {
            header: "Projected revenue",
            rowKey: "projectedRevenue",
        },
        {
            header: "From measure",
            rowKey: "fromMeasure",
        },
        {
            header: "To measure",
            rowKey: "toMeasure",
        },
        {
            header: "Rebate percentage",
            rowKey: "rebatePercentage",
        },
        {
            header: "",
            rowKey: "",
        },
    ],
    CLAIM: [
        {
            header: "Supplier name",
            viewingOption: "Supplier name",
            rowKey: "supplierName",
            showForCountries: ["DE", "NL"],
        },
        {
            header: "Contract Reference",
            viewingOption: "Contract Reference",
            rowKey: "contractRef",
            showForCountries: ["DE", "NL"],
        },
        {
            header: "Claim reference number",
            viewingOption: "Claim reference number",
            rowKey: "claimReferenceNumber",
            showForCountries: ["DE"],
        },
        {
            header: "Claim reference",
            viewingOption: "Claim reference",
            rowKey: "claimReferenceNumber",
            showForCountries: ["GB"],
        },
        {
            header: "Customer/External name",
            viewingOption: "Customer/External name",
            rowKey: "accountName",
            showForCountries: ["GB"],
        },
        {
            header: "Claim type",
            viewingOption: "Claim type",
            rowKey: "datamodelName",
            showForCountries: ["GB"],
        },
        {
            header: "File name",
            viewingOption: "File name",
            rowKey: "fileName",
            showForCountries: ["DE", "NL"],
        },
        {
            header: "File date",
            viewingOption: "File date",
            rowKey: "fileDate",
            showForCountries: ["DE", "NL"],
        },
        {
            header: "Contract ref.",
            viewingOption: "Contract ref.",
            rowKey: "contractRef",
            showForCountries: ["BE"],
        },
        {
            header: "Brand",
            viewingOption: "Brand",
            rowKey: "brandName",
            showForCountries: ["BE"],
        },

        {
            header: "Date from",
            viewingOption: "Date from",
            rowKey: "dateFrom",
            showForCountries: [],
        },
        {
            header: "Date to",
            viewingOption: "Date to",
            rowKey: "dateTo",
            showForCountries: [],
        },
        {
            header: "Payment type",
            viewingOption: "Payment type",
            rowKey: "paymentType",
            showForCountries: ["BE"],
        },
        {
            header: "Claim date",
            viewingOption: "Claim date",
            rowKey: "claimDocumentDate",
            showForCountries: ["GB"],
        },
        {
            header: "SAP release date",
            viewingOption: "SAP release date",
            rowKey: "sapReleaseDate",
            showForCountries: ["GB"],
        },
        {
            header: "Date processed",
            viewingOption: "Date processed",
            rowKey: "dateProcessed",
            showForCountries: ["DE", "NL"],
        },
        {
            header: "Partner claim reference",
            viewingOption: "Partner claim reference",
            rowKey: "claimCustomerReference",
            showForCountries: ["GB"],
        },
        {
            header: "Net rebate amount",
            viewingOption: "Net rebate amount",
            rowKey: "totalRebateValue",
            showForCountries: ["GB"],
        },
        {
            header: "Status",
            viewingOption: "Status",
            rowKey: "status",
            showForCountries: [],
        },
        {
            header: "",
            rowKey: "",
            showForCountries: [],
        },
    ],
    CLAIM_CONTRACT: [
        {
            header: "",
            viewingOption: "",
            rowKey: "",
        },
        {
            header: "Contract Reference",
            viewingOption: "Contract reference",
            rowKey: "reference",
        },
        {
            header: "start date",
            viewingOption: "Start date",
            rowKey: "startDate",
        },
        {
            header: "end date",
            viewingOption: "End date",
            rowKey: "endDate",
        },
        {
            header: "Brand",
            viewingOption: "Brand",
            rowKey: "brandName",
        },
        {
            header: "Primary contract partner",
            viewingOption: "Primary contract partner",
            rowKey: "primaryContractPartner",
        },
        {
            header: "Categories",
            viewingOption: "Categories",
            rowKey: "categories",
            unchecked: true,
        },
        {
            header: "Status",
            viewingOption: "Status",
            rowKey: "status",
        },
    ],
    CLAIM_CONTRACT_SELECTION: [
        {
            header: "",
            viewingOption: "",
            rowKey: "",
        },
        {
            header: "Contract Reference",
            viewingOption: "Contract reference",
            rowKey: "reference",
        },
        {
            header: "Therapeutic Area",
            viewingOption: "Therapeutic Area",
            rowKey: "therapeuticAreaName",
        },
        {
            header: "Brand",
            viewingOption: "Brand",
            rowKey: "brandName",
        },
        {
            header: "Primary contract partner",
            viewingOption: "Primary contract partner",
            rowKey: "primaryContractPartner",
        },
        {
            header: "Product",
            viewingOption: "Product",
            rowKey: "products",
            unchecked: true,
        },
        {
            header: "Categories",
            viewingOption: "Categories",
            rowKey: "categories",
            unchecked: true,
        },
        {
            header: "Start date",
            viewingOption: "Start date",
            rowKey: "startDate",
        },
        {
            header: "End date",
            viewingOption: "End date",
            rowKey: "endDate",
        },
        {
            header: "Status",
            viewingOption: "Status",
            rowKey: "status",
        },
    ],
    BPF_CLAIMS: [
        {
            header: "",
        },
        {
            header: "Supplier name",
        },
        {
            header: "file name",
        },
        {
            header: "file date",
        },
        {
            header: "date from",
        },
        {
            header: "date to",
        },
        {
            header: "date processed",
        },
    ],

    CLAIM_FINANCIAL_TRANSACTIONS: [
        {
            header: "",
        },
        {
            header: "Supplier name",
        },
        {
            header: "file name",
        },
        {
            header: "date from",
        },
        {
            header: "date to",
        },
        {
            header: "total rebate value",
        },
        {
            header: "VAT included",
        },
        {
            header: "status",
        },
    ],
    MAINTENANCE_USERS: [
        {
            header: "First name",
        },
        {
            header: "Last name",
        },
        {
            header: "Email",
        },
        {
            header: "WWID",
        },
        {
            header: "Object ID",
        },
        {
            header: "Active",
        },
        {
            header: "",
        },
    ],
    MAINTENANCE_ROLES: [
        {
            header: "Role Name",
        },
        {
            header: "Role ID",
        },
        {
            header: "Role approval level",
        },
        {
            header: "Country code",
        },
        {
            header: "",
        },
    ],
    BPF_OUTCOME_CONTRACT_SELECTION: [
        {
            header: "",
        },
        {
            header: "Ref",
        },
        {
            header: "Contract partner",
        },
        {
            header: "Additional partners",
        },
        {
            header: "product |& indication",
        },
        {
            header: "valid from |& to",
        },
    ],
    CLAIM_DETAIL_LINES: [
        {
            header: "",
        },
        {
            header: "Cods ID",
            viewingOption: "Cods ID",
            rowKey: "accountCode",
        },
        {
            header: "Account Name",
            viewingOption: "Account Name",
            rowKey: "accountName",
        },
        {
            header: "Product Code",
            viewingOption: "Product Code",
            rowKey: "productCode",
        },
        {
            header: "Product Name",
            viewingOption: "Product Name",
            rowKey: "productName",
        },
        {
            header: "Date",
            viewingOption: "Date",
            rowKey: "date",
        },
        {
            header: "Units",
            viewingOption: "Units",
            rowKey: "unit",
        },
        {
            header: "Contract Price",
            viewingOption: "Contract Price",
            rowKey: "priceCorrectionPrice",
            hiddenForCountries: ["GB"],
        },
        {
            header: "Rebate per unit price",
            viewingOption: "Rebate per unit price",
            rowKey: "priceCorrectionPrice",
            showForCountries: ["GB"],
        },
        {
            header: "JNJ Price",
            viewingOption: "JNJ Price",
            rowKey: "evidencePrice",
        },
        {
            header: "Rebate",
            viewingOption: "Rebate",
            rowKey: "rebate",
        },
        {
            header: "Action",
            viewingOption: "Action",
            rowKey: "priceCorrectionCondition",
        },
        {
            header: "OK/NOK",
            viewingOption: "OK/NOK",
            rowKey: "priceCorrectionStatus",
        },
        {
            header: "Reason",
            viewingOption: "Reason",
            rowKey: "priceCorrectionReason",
        },
        {
            header: "Evidence value",
            viewingOption: "Evidence value",
            rowKey: "evidenceValue",
            unchecked: true,
        },
        {
            header: "Evidence rebate",
            viewingOption: "Evidence rebate",
            rowKey: "evidenceRebate",
            unchecked: true,
        },
        {
            header: "Claim price",
            viewingOption: "Claim price",
            rowKey: "price",
            unchecked: true,
        },
        {
            header: "Claim value",
            viewingOption: "Claim value",
            rowKey: "value",
            unchecked: true,
        },
        {
            header: "",
        },
    ],
    COMPENSATION: [
        {
            header: "Period",
            viewingOption: "Period",
            rowKey: "period",
        },
        {
            header: "Compensation",
            viewingOption: "Compensation",
            rowKey: "compensation",
        },
        {
            header: "Compensation type",
            viewingOption: "Compensation type",
            rowKey: "compensationType",
        },
        {
            header: "Description",
            viewingOption: "Description",
            rowKey: "description",
        },
        {
            header: "Fixed",
            viewingOption: "Fixed",
            rowKey: "fixed",
        },
        {
            header: "Deduct",
            viewingOption: "Deduct",
            rowKey: "deduct",
        },
        {
            header: "Amount",
            viewingOption: "Amount",
            rowKey: "amount",
        },
        {
            header: "Units",
            viewingOption: "Units",
            rowKey: "units",
        },
        {
            header: "Payment date",
            viewingOption: "Payment date",
            rowKey: "paymentDate",
        },
        { header: "" },
    ],
    CLAIM_COMPENSATION: [
        { header: "" },
        {
            header: "Period",
            viewingOption: "Period",
            rowKey: "period",
        },
        {
            header: "Compensation type",
            viewingOption: "Compensation type",
            rowKey: "compensationType",
        },
        {
            header: "Compensation",
            viewingOption: "Compensation",
            rowKey: "compensation",
        },
        {
            header: "Description",
            viewingOption: "Description",
            rowKey: "description",
        },
        {
            header: "Fixed",
            viewingOption: "Fixed",
            rowKey: "fixed",
        },
        {
            header: "Deduct",
            viewingOption: "Deduct",
            rowKey: "deduct",
        },
        {
            header: "Amount",
            viewingOption: "Amount",
            rowKey: "amount",
        },
        {
            header: "Payment date",
            viewingOption: "Payment date",
            rowKey: "paymentDate",
        },
        {
            header: "Number",
        },
    ],
    MAINTENANCE_CONTRACT_MILESTONES_DMN: [
        {
            header: "Contract Reference",
            viewingOption: "Contract reference",
            rowKey: "contractRef",
        },
        {
            header: "Country ISO Code",
            viewingOption: "Country ISO Code",
            rowKey: "countryIsoCode",
        },
        {
            header: "Type",
            viewingOption: "Type",
            rowKey: "contractType",
        },
        {
            header: "",
            viewingOption: "",
            rowKey: "",
        },
    ],
    GENTLEMAN_AGREEMENT: [
        {
            header: "Price",
            viewingOption: "Price",
            rowKey: "price",
        },
        {
            header: "Currency",
            viewingOption: "Currency",
            rowKey: "currency",
        },
        {
            header: "Valid From",
            viewingOption: "Valid From",
            rowKey: "validFrom",
        },
        {
            header: "Valid To",
            viewingOption: "Valid To",
            rowKey: "validTo",
        },
        {
            header: "Status",
            viewingOption: "Status",
            rowKey: "status",
        },
        {
            header: "",
        },
    ],
    ADVANCE_CLAIM: [
        {
            header: "",
            rowKey: "",
        },
        {
            header: "Contract Reference",
            rowKey: "contractRef",
        },
        {
            header: "Customer/External name",
            rowKey: "accountName",
        },
        {
            header: "File name",
            rowKey: "fileName",
        },
        {
            header: "File date",
            rowKey: "fileDate",
        },
        {
            header: "Date from",
            rowKey: "dateFrom",
        },
        {
            header: "Date to",

            rowKey: "dateTo",
        },
        {
            header: "Date processed",
            rowKey: "dateProcessed",
        },
        {
            header: "Status",
            rowKey: "status",
        },
    ],
};
